import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import auth from './modules/auth'
import admin from './modules/admin'

Vue.use(Vuex)

const state = {
    globalError: ''
}

export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations,
    modules: {
        auth,
        admin,
    }
})
